export enum FilterScreenBreakpoint {
  Sort = 52.5,
  Geometry = 48.125,
  GeometryAndSort = 53.75,
  GeometryAndServices = 62.25,
  All = 67.5,
}

export interface FilterContainerProps {
  breakpoint?: FilterScreenBreakpoint;
  alwaysShow?: boolean;
  className?: string;
}
